import { createReducer, on } from '@ngrx/store';
import { initialLogAnalysisSlice } from '../initial-slices';
import * as LogAnalysisActions from './log-analysis.actions';
import { LogAnalysisSlice } from '../app-state';

export const logAnalysisReducer = createReducer(
  initialLogAnalysisSlice,
  on(LogAnalysisActions.setLogAnalysisResult, (state, props): LogAnalysisSlice => {
    const pipelineRunResults = { ...state.pipelineRunResults };
    pipelineRunResults[props.pipelineRunId] = props.aiLogAnalysis;
    return { ...state, pipelineRunResults };
  }),
);
